<div fxLayoutAlign="space-between center">
    <div>{{ role.id }}</div>
    <div>
        <button mat-icon-button (click)="displayAclsInformation(role)" color="primary" style="width: 32px;height: 32px;padding:0;margin-left: 0.7rem;">
            <mat-icon class="syn-info-ico" svgIcon="information-outline"></mat-icon>
        </button>
    </div>
</div>
